import { action, observable, computed } from 'mobx';
import { fromPromise } from 'mobx-utils';
import { memoize } from 'lodash';

const emptyPromise = s => new Promise(resolve => resolve(s));

export default class File {
  @observable uploadAttempt = 0;
  @observable file = {};
  @observable status = 'uploading';
  @observable location = '';
  @observable percent = 0;

  constructor(settingsStore, request, file, id) {
    this.uid = id;
    this.id = id;
    this.settingsStore = settingsStore;
    this.request = request;
    this.file = file;
    this.size = file.size;
    this.name = file.name;
  }

  memoEmptyUpload = memoize(() => fromPromise(emptyPromise(), {}));
  cacheUpload = memoize(file => {
    if (!this.fileSlots) return this.memoEmptyUpload();

    return fromPromise(
      this.request(
        'putFile',
        {
          put_url: this.fileSlots.file_slot.put_url,
        },
        {},
        file,
        {
          'Content-Type': file.type || 'application',
          Authorization: null,
        },
        this.onUploadProgress
      )
    );
  });

  @computed
  get uploadPromise() {
    if (!this.uploadAttempt) return this.memoEmptyUpload();
    return this.cacheUpload(this.file);
  }

  @computed
  get isUploaded() {
    return !!(this.uploadAttempt && this.uploadPromise.state === 'fulfilled');
  }

  @computed
  get isUploading() {
    return !!(this.uploadAttempt && this.uploadPromise.state === 'pending');
  }

  @computed
  get isUploadError() {
    return !!(this.uploadAttempt && this.uploadPromise.state === 'rejected');
  }

  @action
  onUploadProgress = p => {
    this.percent = parseFloat((p.loaded / p.total) * 100).toFixed(0);
  };

  @action
  uploadToFileSlot = value => {
    this.fileSlots = value;
    this.cacheUpload(this.file);
  };

  @action
  updateFileOnUploadSuccess = onSuccess => {
    const location = this.fileSlots.file_slot.get_url;
    onSuccess(location);
    this.location = location;
    this.status = 'done';
  };

  @action
  updateFileOnUploadError = (onError, err) => {
    onError(err);
    this.status = 'error';
  };

  @action
  upload = (onSuccess, onError) => {
    this.uploadAttempt += 1;
    return this.request(
      'getFilePassage',
      { cuid: this.settingsStore.cuid },
      {
        name: this.name,
        size: this.size,
      },
      {}
    )
      .then(value => this.uploadToFileSlot(value))
      .then(() => this.updateFileOnUploadSuccess(onSuccess))
      .catch(err => this.updateFileOnUploadError(onError, err));
  };
}



// WEBPACK FOOTER //
// ./src/stores/file.js